export const environment = {
  production: false,
  animal: '🐊',
  apiUrl: 'https://api.qa-order2go.bayer.com',
  // apiUrl: 'https://localhost:5001/api',
  excludedUrl: [
    /*'/assets/i18n/es.json',
    '/assets/i18n/en.json',
    'assets/config.json',*/
    'assets/',
    '/assets/',
    'vigiloo',
    'rtv-b2b-api.vigiloo.net',
    'CReporteExcelUsuarios',
    'AUsuariosExcel',
    'descargarComprobante',
    'cEstadoComprobante',
    'DescargarFactura',
    'CReporteExcelCuentas'
  ]
};
